import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { TableSkeleton } from "@/components/skeletons/table-skeleton";
export const Route = createFileRoute("/_authed/_org/organization")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<TableSkeleton />}>
      <Outlet />
    </Suspense>
  );
}
